var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1784",
    "data-name": "Rectangle 1784",
    width: 15,
    height: 15,
    transform: "translate(-1 -1)",
    fill: "#fff",
    stroke: "#16161a",
    strokeWidth: 1.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3219",
    "data-name": "Group 3219",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3218",
    "data-name": "Group 3218",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8494",
    "data-name": "Path 8494",
    d: "M6.091,3.1A2.1,2.1,0,0,1,8.192,1h3.677a2.1,2.1,0,0,1,2.1,2.1v7.354a2.1,2.1,0,0,1-2.1,2.1H8.192a2.1,2.1,0,0,1-2.1-2.1",
    transform: "translate(-1.692 -0.278)",
    fill: "#fff",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_164",
    "data-name": "Line 164",
    x1: 6.829,
    transform: "translate(1.247 6.5)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_165",
    "data-name": "Line 165",
    x1: 2.101,
    y1: 2.101,
    transform: "translate(0.722 6.5)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_166",
    "data-name": "Line 166",
    x1: 2.101,
    y2: 2.101,
    transform: "translate(0.722 4.399)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1917bfbfb31c6bd8e0c4019bfb8f2884.svg";
export { ForwardRef as ReactComponent };